import {
    assignmentsColumns, sortDirection
} from "../../components/assignments/assignmentsPage/assignmentsList/AssignmentsConstants";

export default {
    assignments: [],
    totalAssignments: 0,
    sortOptions: {
        columnName: assignmentsColumns.startDate,
        direction: sortDirection.ascending
    }
};
